import { DataEntry } from 'models/data';
import { Measure } from 'services/model/model.service';

interface HasMeasureValueParams {
  entry: DataEntry;
  measure: Measure;
  benchmark?: string;
  compare?: boolean;
  requirePositive?: boolean;
}

export const hasMeasureValue = ({
  entry,
  measure,
  benchmark,
  compare = false,
  requirePositive = false,
}: HasMeasureValueParams): boolean => {
  const values = benchmark
    ? entry.benchmarks?.[benchmark]?.[compare ? 'compareValues' : 'values']
    : entry[compare ? 'compareValues' : 'values'];

  return !!values && measure.code in values && (!requirePositive || measure.getValue(values) > 0);
};
